<template>
  <div id="configurations">
    <div class="main">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane :label="$t('cmsg.systemParams')" name="systemParams">
          <el-card class="cf_card" shadow="never">
            <h3>English system params:</h3>
            <el-form
              :model="enSiteSPForm"
              size="mini"
              style="display:block"
              ref="enSiteSPForm"
              :inline="true"
              v-if="perms.indexOf('dental.add_aoralscan')>-1"
            >
              <el-form-item prop="other" required label="System Title">
                <el-input type="text" v-model="enSiteSPForm.other">
                  <el-button
                    slot="append"
                    type="primary"
                    @click="saveSubmit(enSiteSPForm,'enSiteSPForm')"
                    :loading="enSiteSPForm.loading"
                  >{{$t('cmsg.save')}}</el-button>
                </el-input>
                <el-input type="hidden" v-model="enSiteSPForm.keyName"></el-input>
                <el-input type="hidden" v-model="enSiteSPForm.id"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="perms.indexOf('dental.add_aoralscan')< 0">System Title: {{enSiteSPForm.other}}</div>
            <el-form
              :model="enCPSPForm"
              size="mini"
              style="display:block"
              ref="enCPSPForm"
              :inline="true"
              v-if="perms.indexOf('dental.add_aoralscan')>-1"
            >
              <el-form-item prop="other" required label="Copyright">
                <el-input type="text" v-model="enCPSPForm.other">
                  <el-button
                    slot="append"
                    type="primary"
                    @click="saveSubmit(enCPSPForm,'enCPSPForm')"
                    :loading="enCPSPForm.loading"
                  >{{$t('cmsg.save')}}</el-button>
                </el-input>
                <el-input type="hidden" v-model="enCPSPForm.keyName"></el-input>
                <el-input type="hidden" v-model="enCPSPForm.id"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="perms.indexOf('dental.add_aoralscan')< 0">Copyright: {{enCPSPForm.other}}</div>
            <el-form
              :model="enLogoSPForm"
              size="mini"
              style="display:block"
              ref="enLogoSPForm"
              :inline="true"
              v-if="perms.indexOf('dental.add_aoralscan')>-1"
            >
              <el-form-item prop="other" required label="Logo">
                <no-ssr>
                  <uploader
                    ref="enLogoUploader"
                    :options="uploaderOptions"
                    @file-success="enLogoUploaded"
                    class="new-doc-uploader"
                  >
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-btn>{{$t('cmsg.selectFile')}}</uploader-btn>
                    <uploader-list></uploader-list>
                  </uploader>
                </no-ssr>
                <el-input type="hidden" v-model="enLogoSPForm.other"></el-input>
                <el-input type="hidden" v-model="enLogoSPForm.keyName"></el-input>
                <el-input type="hidden" v-model="enLogoSPForm.id"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="perms.indexOf('dental.add_aoralscan')< 0">Logo: </div>
                <el-image
                  style="width: 100px; height: 100px"
                  :src="enLogoSPForm.other+'?x-oss-process=image/resize,m_pad,h_100,w_100'"
                  fit="fit"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
            <el-form
              :model="enBannerSPForm"
              size="mini"
              style="display:block"
              ref="enBannerSPForm"
              :inline="true"
              v-if="perms.indexOf('dental.add_aoralscan')>-1"
            >
              <el-form-item prop="other" required label="Banner">
                <no-ssr>
                  <uploader
                    ref="enBannerUploader"
                    :options="uploaderOptions"
                    @file-success="enBannerUploaded"
                    class="new-doc-uploader"
                  >
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-btn>{{$t('cmsg.selectFile')}}</uploader-btn>
                    <uploader-list></uploader-list>
                  </uploader>
                </no-ssr>
                <el-input type="hidden" v-model="enBannerSPForm.other"></el-input>
                <el-input type="hidden" v-model="enBannerSPForm.keyName"></el-input>
                <el-input type="hidden" v-model="enBannerSPForm.id"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="perms.indexOf('dental.add_aoralscan')< 0">Banner: </div>
                <el-image
                  style="width: 384px"
                  :src="enBannerSPForm.other+'?x-oss-process=image/resize,m_pad,h_216,w_384'"
                  fit="fit"
                  :preview-src-list="[enBannerSPForm.other+'?x-oss-process=image/resize,m_pad,h_1080,w_1920']"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
          </el-card>
          <el-divider direction="vertical"></el-divider>
          <el-card class="cf_card" shadow="never">
            <h3>中文版系统参数：</h3>
            <el-form
              :model="cnSiteSPForm"
              size="mini"
              style="display:block"
              ref="cnSiteSPForm"
              :inline="true"
              v-if="perms.indexOf('dental.add_aoralscan')>-1"
            >
              <el-form-item prop="other" required label="系统名称">
                <el-input type="text" v-model="cnSiteSPForm.other">
                  <el-button
                    slot="append"
                    type="primary"
                    @click="saveSubmit(cnSiteSPForm,'cnSiteSPForm')"
                    :loading="cnSiteSPForm.loading"
                  >{{$t('cmsg.save')}}</el-button>
                </el-input>
                <el-input type="hidden" v-model="cnSiteSPForm.keyName"></el-input>
                <el-input type="hidden" v-model="cnSiteSPForm.id"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="perms.indexOf('dental.add_aoralscan')< 0">系统名称: {{cnSiteSPForm.other}}</div>
            <el-form
              :model="cnCPSPForm"
              size="mini"
              style="display:block"
              ref="cnCPSPForm"
              :inline="true"
              v-if="perms.indexOf('dental.add_aoralscan')>-1"
            >
              <el-form-item prop="other" required label="版权信息">
                <el-input type="text" v-model="cnCPSPForm.other">
                  <el-button
                    slot="append"
                    type="primary"
                    @click="saveSubmit(cnCPSPForm,'cnCPSPForm')"
                    :loading="cnCPSPForm.loading"
                  >{{$t('cmsg.save')}}</el-button>
                </el-input>
                <el-input type="hidden" v-model="cnCPSPForm.keyName"></el-input>
                <el-input type="hidden" v-model="cnCPSPForm.id"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="perms.indexOf('dental.add_aoralscan')< 0">版权信息: {{cnCPSPForm.other}}</div>
            <el-form
              :model="cnLogoSPForm"
              size="mini"
              style="display:block"
              ref="cnLogoSPForm"
              :inline="true"
              v-if="perms.indexOf('dental.add_aoralscan')>-1"
            >
              <el-form-item prop="other" required label="Logo图">
                <no-ssr>
                  <uploader
                    ref="cnLogoUploader"
                    :options="uploaderOptions"
                    @file-success="cnLogoUploaded"
                    class="new-doc-uploader"
                  >
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-btn>{{$t('cmsg.selectFile')}}</uploader-btn>
                    <uploader-list></uploader-list>
                  </uploader>
                </no-ssr>
                <el-input type="hidden" v-model="cnLogoSPForm.other"></el-input>
                <el-input type="hidden" v-model="cnLogoSPForm.keyName"></el-input>
                <el-input type="hidden" v-model="cnLogoSPForm.id"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="perms.indexOf('dental.add_aoralscan')< 0">Logo图: </div>
                <el-image
                  style="width: 100px; height: 100px"
                  :src="cnLogoSPForm.other+'?x-oss-process=image/resize,m_pad,h_100,w_100'"
                  fit="fit"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
            <el-form
              :model="cnBannerSPForm"
              size="mini"
              style="display:block"
              ref="cnBannerSPForm"
              :inline="true"
              v-if="perms.indexOf('dental.add_aoralscan')>-1"
            >
              <el-form-item prop="other" required label="Banner图">
                <no-ssr>
                  <uploader
                    ref="cnBannerUploader"
                    :options="uploaderOptions"
                    @file-success="cnBannerUploaded"
                    class="new-doc-uploader"
                  >
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-btn>{{$t('cmsg.selectFile')}}</uploader-btn>
                    <uploader-list></uploader-list>
                  </uploader>
                </no-ssr>
                <el-input type="hidden" v-model="cnBannerSPForm.other"></el-input>
                <el-input type="hidden" v-model="cnBannerSPForm.keyName"></el-input>
                <el-input type="hidden" v-model="cnBannerSPForm.id"></el-input>
              </el-form-item>
            </el-form>
            <div v-if="perms.indexOf('dental.add_aoralscan')< 0">Banner图: </div>
                <el-image
                  style="width: 384px"
                  :src="cnBannerSPForm.other+'?x-oss-process=image/resize,m_pad,h_216,w_384'"
                  :preview-src-list="[cnBannerSPForm.other+'?x-oss-process=image/resize,m_pad,h_1080,w_1920']"
                  fit="fit"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
          </el-card>
        </el-tab-pane>
        <el-tab-pane :label="$t('cmsg.interfaceDoc')" name="interfaceDoc" v-if="perms.indexOf('resource.save_resource')>-1">
          <el-form
            :model="interfaceDocForm"
            size="mini"
            style="display:block"
            ref="interfaceDocForm"
          >
            <el-form-item prop="other" required>
              <el-input type="textarea" v-model="interfaceDocForm.other" autosize :rows="25"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="saveSubmit(interfaceDocForm, 'interfaceDocForm')"
                :loading="interfaceDocForm.loading"
              >{{$t('cmsg.submit')}}</el-button>
              <el-input type="hidden" v-model="interfaceDocForm.keyName"></el-input>
              <el-input type="hidden" v-model="interfaceDocForm.id"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import NoSSR from "vue-no-ssr";
export default {
  components: {
    "no-ssr": NoSSR
  },
  data() {
    return {
      uploaderOptions: {
        target: "/api/mpupc?category=sysParams&bucket=pub&geo=true",
        allowDuplicateUploads: true,
        singleFile: true,
        initFileFn: this.fileAdded,
        simultaneousUploads: 10,
        chunkSize: 5* 1024 * 1024,
        speedSmoothingFactor: 0.02,
        maxChunkRetries: undefined
      },
      cdnUrl: {},
      activeName: "systemParams"
    };
  },
  methods: {
    cnBannerUploaded(rootFile, file, message, chunk) {
      console.log(message);
      var res = JSON.parse(message);
      if (res.status === "success") {
        this.cnBannerSPForm.other = `${this.cdnUrl[res.result.bucket]}${
          res.result.dfs_id
        }`;
        this.saveSubmit(this.cnBannerSPForm, "cnBannerSPForm");
      }
    },
    cnLogoUploaded(rootFile, file, message, chunk) {
      console.log(message);
      var res = JSON.parse(message);
      if (res.status === "success") {
        this.cnLogoSPForm.other = `${this.cdnUrl[res.result.bucket]}${
          res.result.dfs_id
        }`;
        this.saveSubmit(this.cnLogoSPForm, "cnLogoSPForm");
      }
    },
    enBannerUploaded(rootFile, file, message, chunk) {
      console.log(message);
      var res = JSON.parse(message);
      if (res.status === "success") {
        this.enBannerSPForm.other = `${this.cdnUrl[res.result.bucket]}${
          res.result.dfs_id
        }`;
        this.saveSubmit(this.enBannerSPForm, "enBannerSPForm");
      }
    },
    enLogoUploaded(rootFile, file, message, chunk) {
      console.log(message);
      var res = JSON.parse(message);
      if (res.status === "success") {
        this.enLogoSPForm.other = `${this.cdnUrl[res.result.bucket]}${
          res.result.dfs_id
        }`;
        this.saveSubmit(this.enLogoSPForm, "enLogoSPForm");
      }
    },
    fileAdded(file) {
      if (file.size > 1000 * 1024 * 1024) {
        file.uploader.opts.chunkSize = 10 * 1024 * 1024;
      }
    },
    saveSubmit(obj, name) {
      obj.loading = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/u/settings/rs/save", obj, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
              }
              obj.loading = false;
              this.reloadP();
            })
            .catch(res => console.log(res));
        } else {
          obj.loading = false;
          return false;
        }
      });
      obj.loading = false;
    },
    reloadP() {
      var t = this;
      setTimeout(function() {
        window.location = t.$router.resolve({
          name: "configurations",
          query: t.$route.query
        }).href;
      }, 3000);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    initSystemParams() {},
    initInterfaceDoc() {},
    initForm() {
      switch (this.activeName) {
        case "systemParams":
          this.initSystemParams();
          break;
        case "interfaceDoc":
          this.initInterfaceDoc();
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    // console.log("this.perms: ", this.$store.state.perms);
    // console.log("this.$perms: ", this.$perms);
    // this.initForm();
    console.log("this.perms: ", this.perms);
    console.log("mounted:", pub.cdnUrl);
    if (pub && pub.cdnUrl) {
      this.cdnUrl = pub.cdnUrl;
    }
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.configurations")
    };
  },
  async asyncData(context) {
    let perms = [];
    await context.$axios
      .get(`/api/u/settings/b/up`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          perms = res.data.result;
        }
      })
      .catch(e => {
        console.log(e);
      });
    let interfaceDocForm = {
      id: "",
      nameCode: "blob_content",
      keyName: "dentalscan",
      keyValue: "dentalscan",
      other: ""
    };
    await context.$axios
      .get(`/api/u/settings/bb/blob_content/dentalscan`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          interfaceDocForm.id = res.data.result.id;
          interfaceDocForm.other = res.data.result.other;
        }
      })
      .catch(e => {
        console.log(e);
      });
    let enLogoSPForm = {
      loading: false,
      id: "",
      nameCode: "sysParams",
      keyName: "logo",
      keyValue: "en",
      other: ""
    };
    let cnLogoSPForm = {
      loading: false,
      id: "",
      nameCode: "sysParams",
      keyName: "logo",
      keyValue: "cn",
      other: ""
    };
    let enSiteSPForm = {
      loading: false,
      id: "",
      nameCode: "sysParams",
      keyName: "title",
      keyValue: "en",
      other: ""
    };
    let cnSiteSPForm = {
      loading: false,
      id: "",
      nameCode: "sysParams",
      keyName: "title",
      keyValue: "cn",
      other: ""
    };
    let enCPSPForm = {
      loading: false,
      id: "",
      nameCode: "sysParams",
      keyName: "copyright",
      keyValue: "en",
      other: ""
    };
    let cnCPSPForm = {
      loading: false,
      id: "",
      nameCode: "sysParams",
      keyName: "copyright",
      keyValue: "cn",
      other: ""
    };
    let enBannerSPForm = {
      loading: false,
      id: "",
      nameCode: "sysParams",
      keyName: "banner",
      keyValue: "en",
      other: ""
    };
    let cnBannerSPForm = {
      loading: false,
      id: "",
      nameCode: "sysParams",
      keyName: "banner",
      keyValue: "cn",
      other: ""
    };
    await context.$axios
      .get(`/api/u/settings/sp/sysParams`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          // console.log(res.data.result);
          res.data.result.forEach(item => {
            if (item.keyName === "banner" && item.keyValue === "cn") {
              cnBannerSPForm.id = item.id;
              cnBannerSPForm.other = item.other;
            }
            if (item.keyName === "banner" && item.keyValue === "en") {
              enBannerSPForm.id = item.id;
              enBannerSPForm.other = item.other;
            }
            if (item.keyName === "copyright" && item.keyValue === "en") {
              enCPSPForm.id = item.id;
              enCPSPForm.other = item.other;
            }
            if (item.keyName === "copyright" && item.keyValue === "cn") {
              cnCPSPForm.id = item.id;
              cnCPSPForm.other = item.other;
            }
            if (item.keyName === "title" && item.keyValue === "en") {
              // console.log("enSiteSPForm");
              enSiteSPForm.id = item.id;
              enSiteSPForm.other = item.other;
            }
            if (item.keyName === "title" && item.keyValue === "cn") {
              cnSiteSPForm.id = item.id;
              cnSiteSPForm.other = item.other;
            }
            if (item.keyName === "logo" && item.keyValue === "en") {
              enLogoSPForm.id = item.id;
              enLogoSPForm.other = item.other;
            }
            if (item.keyName === "logo" && item.keyValue === "cn") {
              cnLogoSPForm.id = item.id;
              cnLogoSPForm.other = item.other;
            }
          });
        }
      })
      .catch(e => {
        console.log(e);
      });
    // console.log("perms: ",perms);
    // console.log("enLogoSPForm: ", enLogoSPForm);
    // console.log("enLogoSPForm: ", enLogoSPForm);
    return {
      perms: perms,
      interfaceDocForm: interfaceDocForm,
      cnLogoSPForm: cnLogoSPForm,
      enLogoSPForm: enLogoSPForm,
      cnSiteSPForm: cnSiteSPForm,
      enSiteSPForm: enSiteSPForm,
      cnCPSPForm: cnCPSPForm,
      enCPSPForm: enCPSPForm,
      cnBannerSPForm: cnBannerSPForm,
      enBannerSPForm: enBannerSPForm
    };
  }
};
</script>
<style lang="scss">
.fileDownPopover {
  .el-button {
    display: block;
    margin-left: 0px;
  }
}
#configurations {
  .main {
    background-color: #f7f9fb;
    padding: 15px;
    text-align: left;
    .cf_card {
      width: auto;
      display: inline-table;
      border-width: 0px;
    }
    .el-divider--vertical {
      height: 700px;
      vertical-align: text-top;
    }
    .case_nav {
      display: flex;
      overflow: auto;
    }
    .el-menu-item {
      display: inline;
      border-top: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
    }
    .el-menu-item.is-active {
      background-color: #f3f3f3;
    }
    .el-menu-item:last-of-type {
      border-right: 1px solid #e6e6e6;
    }
    .hidden_delivery {
      display: none;
    }
    .large_preview {
      width: 80%;
    }
    .large_preview .el-message-box__content {
      overflow: auto;
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 0px 0px 15px 0px;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border-top-width: 0px;
    }
    .case_btn {
      margin-right: 5px;
      margin-bottom: 5px;
      margin-left: 0px !important;
    }
    .search_expand_area {
      display: none;
    }
    .search_form {
      display: block;
    }
    @media screen and (min-width: 1020px) {
      .search_expand_area {
        display: none;
      }
      .search_form {
        display: block;
      }
    }
    .el-table__expanded-cell[class*="cell"] {
      padding-bottom: 0px !important;
    }
    @media screen and (max-width: 1020px) {
      .search_expand_area {
        display: block;
      }
      .search_form {
        display: none;
      }
      .el-menu-item [class^="el-icon-"] {
        margin-right: 0px;
      }
      .el-menu-item:not(.is-active) .dp_title {
        display: none;
        /* display: inline; */
      }
      .is-active .dp_title {
        display: inline;
      }
      .el-menu-item {
        padding: 0 0px 0 5px;
      }
      .el-pager li:not(.active) {
        display: none;
      }
    }
  }
}
</style>
